<template>
    <div v-if="show||showWrap">
        <div v-if="show" :class="['loading_container',{loading_done: status.isError||status.isEmpty}]">
            <template v-if="status.isLoading && !status.isError">
                <span class="loading">
                    <i class="el-icon-loading" />
                    <br>
                    <span>{{ loadingText }}</span>
                </span>
            </template>
            <template v-if="!status.isLoading && status.isEmpty">
                <span>{{ noText }}</span>
            </template>
            <template v-if="!status.isLoading && status.isError">
                <span class="error_text">
                    <slot
                        name="error"
                        :errorText="errorText">
                        <template v-if="showRefresh">
                            {{ errorText?errorText:"出错了" }},点击
                            <a @click="refresh">
                                刷新
                            </a>重试
                        </template>
                        <template v-else>
                            {{ errorText?errorText:"出错了" }},请刷新页面重试
                        </template>
                    </slot>
                </span>
            </template>
        </div>
        <template v-if="status.hasOwnProperty('isDone')">
            <template v-if="status.isDone">
                <slot />
            </template>
        </template>
        <template v-else>
            <template v-if="!status.isLoading&&!status.isError&&!status.isEmpty">
                <slot />
            </template>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: Object,
            default() {
                return {
                    isLoading: false,
                    isError: false,
                    isEmpty: false,
                    isDone: false,
                    errMsg: ""
                };
            }
        },
        loadingTop: {
            type: Number,
            default: 0
        },
        loadingBg: {
            type: String,
            default: "rgba(255, 255, 255, 0.7)"
        },
        doneTop: {
            type: Number,
            default: 0
        },
        noText: {
            type: String,
            default: "暂无数据"
        },
        fatherMinHeight: {
            type: Number,
            default: 80
        },
        loadingText: {
            type: String,
            default: "加载中"
        }
    },
    data() {
        return {
            showRefresh: false,
            parentPosition: "",
            parentMinHeight: ""
        };
    },
    watch: {
        "status.isLoading" () {
            if (this.status.isLoading) {
                this.status.isError = false;
                this.status.isEmpty = false;
                this.setTop(this.loadingTop, "paddingTop");
            } else {
                if (this.status.hasOwnProperty("isDone")) {
                    this.status.isDone = true;
                }
                if (this.status.isError || this.status.isEmpty) {
                    this.setTop(this.doneTop);
                }
            }
        },
        "status.isError" () {
            if (this.status.isError) {
                this.setTop(this.doneTop);
                if (this.status.hasOwnProperty("isDone")) {
                    this.status.isDone = true;
                }
                this.status.isLoading = false;
            }
        },
        "status.isEmpty" () {
            if (this.status.isEmpty) {
                this.setTop(this.doneTop);
                if (this.status.hasOwnProperty("isDone")) {
                    this.status.isDone = true;
                }
                this.status.isLoading = false;
            }
        },
        "status.isDone"() {
            this.status.isLoading = false;
        }
    },
    computed: {
        show() {
            return this.status.isLoading || this.status.isError || this.status.isEmpty;
        },
        showWrap() {
            if (this.$slots.default) {
                if (this.status.hasOwnProperty('isDone')) {
                    if (this.status.isDone) {
                        return true;
                    }
                } else if (!this.status.isLoading && !this.status.isError && !this.status.isEmpty) {
                    return true;
                }
            }
            return false;
        },
        errorText() {
            let text;
            if (this.status.errMsg.message) {
                text = this.status.errMsg.message;
            } else if (this.status.errMsg.msg) {
                text = this.status.errMsg.msg;
            } else {
                text = this.status.errMsg.toString();
            }
            return text;
        }
    },
    methods: {
        getStyle(obj, attr) {
            if(window.getComputedStyle) {
                return window.getComputedStyle(obj,null)[attr];
            } else {
                return obj.currentStyle[attr];
            }
        },
        setTop(topSize, type) {
            this.$nextTick(() => {
                if (!this.$el.getElementsByClassName) {
                    return;
                }
                let loadDom = this.$el.getElementsByClassName(".loading_container")[0];
                if (!loadDom) {
                    return;
                }
                loadDom.style.background = this.loadingBg;
                if (type == "paddingTop") {
                    loadDom.style.paddingTop = topSize + "px";
                    loadDom.style.top = 0;
                    return;
                }
                loadDom.style.paddingTop = 0;
                loadDom.style.top = topSize + "px";
            });

        },
        getFatherStyle() {
            if (this.parentPosition == "") {
                this.parentPosition = this.getStyle(this.$el.parentNode, "position");
            }
            if (this.parentMinHeight == "") {
                this.parentMinHeight = this.getStyle(this.$el.parentNode, "minHeight");
            }
        },
        setFatherStyle() {
            if (this.parentMinHeight < this.fatherMinHeight + 'px') {
                this.$el.parentNode.style.minHeight = this.fatherMinHeight + "px";
            }
            if (this.parentPosition != "relative") {
                this.$el.parentNode.style.position = this.parentPosition;
            }
        },
        refresh() {
            this.status.isLoading = true;
            this.$emit("refresh");
        }
    },
    mounted() {
        this.getFatherStyle();
        this.setFatherStyle();
        this.setTop(this.loadingTop, "paddingTop");
        this.showRefresh = this.$listeners.refresh ? true : false;
    }
};
</script>

<style scoped>
.loading_container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.7);
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    z-index: 10;
    color: orange;
    text-align: center;
}
.error_text {
    color: #de6068;
}
.loading span {
    font-size: 12px;
}
.loading_done {
    font-size: 14px;
    z-index: 1;
    background-color: inherit;
}
a {
    color: #00b7ef;
    cursor: pointer;
}
</style>
